import React, { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Container, Card, Row, Col } from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

const cardStyle = {
  backgroundColor: "black",
  borderRadius: "15px",
  //overflow: "hidden",
  height: "400px",
  width: "250px",
  filter: "grayscale(100%) opacity(70%)", // เพิ่มฟิลเตอร์ให้ดูจางลงเหมือนไม่ได้เลือก
  transition: "filter 0.3s ease-in-out", // เพิ่ม transition เพื่อให้ดูนุ่มนวลเวลามีการเปลี่ยนแปลง
};

const SelectcardStyle = {
  backgroundColor: "black",
  borderRadius: "15px",
  //overflow: "hidden",
  height: "400px",
  width: "250px",
  border: "5px solid #60B731",
  scale: "1.1",

};

const CardPlan = ({ packageData, selectPlan, setSelectPlan }) => {
  //console.log("Child selectPlan", selectPlan);
  //console.log("card props", props);

  const swiperRef = useRef(null); // ใช้ Ref เพื่อเก็บ instance ของ Swiper

  const packages =
    Array.isArray(packageData) && packageData.length > 0
      ? packageData.map((pkg) => ({
          id_subscription_plan_table: pkg.id_subscription_plan_table,
          id_subscription_plan: pkg.id_subscription_plan,
          name_subscription_plan: pkg.name_subscription_plan,
          installment_plan: pkg.installment_plan,
          price: pkg.price,
          price_per_unit: pkg.price_per_unit,
          subscription_plan_detail: pkg.subscription_plan_detail,
        }))
      : [];

  //console.log("packages", packages);

  // หา index ของแพ็กเกจที่เลือก
  const selectedIndex = packages.findIndex(
    (pkg) => pkg.id_subscription_plan_table === selectPlan
  );

  useEffect(() => {
    console.log("selectPlan", selectPlan);

    if (swiperRef.current && selectedIndex !== -1) {
      swiperRef.current.slideTo(selectedIndex); // เลื่อนไปยัง Slide ที่เลือก
    }
  }, [selectPlan, selectedIndex]);

  const handleSelectPlan = (id) => {
    setSelectPlan(id); // อัปเดตแพ็กเกจที่เลือก
  };

  return (
    <Container>
      {/* <h4 className="mb-4 font-weight-bold">Reconfirm Your Plan</h4> */}
      <Row className="mb-2">
        <Col className="d-flex justify-content-center p-0 m-0">
          <Swiper
            style={{
              padding: "8px 0",
              margin: "0 auto",              
              overflow: "hidden",
            }}
            //Options
            //autoWidth={true}
            centeredSlides={true}
            slidesPerView="auto"
            spaceBetween={10}
            modules={[Navigation, Pagination]}
            breakpoints={{
              768: { slidesPerView: 2 },
              992: { slidesPerView: 2 },
              1200: { slidesPerView: packages.length < 3 ? packages.length : 3 },
            }}
            navigation
            pagination={{ clickable: true }}
            onSwiper={(swiper) => (swiperRef.current = swiper)} // เก็บ instance ของ Swiper
          >
            {packages.map((pkg, index) => (
              <SwiperSlide
                loop={true}                
                key={index}
                className="p-3 mt-5"
                style={{
                  display: "flex",
                  justifyContent: "center", // จัดกึ่งกลางเนื้อหา
                  height: "100%", // ความสูงเท่ากับความสูงของ Swiper
                }}
              >
                <Card
                  className=""
                  style={{
                    padding: "15px",
                    borderRadius: "12.5px",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    ...(selectPlan === pkg.id_subscription_plan_table
                      ? SelectcardStyle
                      : cardStyle),
                  }}
                  onClick={() => handleSelectPlan(pkg.id_subscription_plan_table)}
                >
                  <Card.Body className="d-flex flex-column justify-content-between text-center p-0">
                    <div
                      className="d-flex flex-column justify-content-between text-center"
                      style={{ height: "100px" }}
                    >
                      <h4
                        style={{
                          color: "lime",
                          minHeight: "40px", // ความสูงขั้นต่ำของชื่อแพ็กเกจ
                          marginBottom: "8px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {pkg.name_subscription_plan}
                      </h4>

                      <h2
                        style={{
                          color: "white",
                          minHeight: "50px", // ความสูงขั้นต่ำของราคา
                          marginBottom: "8px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        ฿{pkg.price}
                      </h2>

                      <p
                        style={{
                          color: "#bbb",
                          minHeight: "30px", // ความสูงขั้นต่ำของรายละเอียด
                          marginBottom: "16px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {pkg.installment_plan}
                      </p>
                    </div>

                    {/* Subscription Plan Detail */}
                    <div
                      className="d-flex flex-column align-items-center"
                      style={{
                        height: "260px",
                      }}
                    >
                      <PerfectScrollbar
                        className="p-0 m-0"
                        style={{ width: "100%", maxHeight: "220px",  overflow: "hidden",}}
                      >
                        {pkg.subscription_plan_detail.map((plan, index) => (
                          <div
                            key={index}
                            className="w-100"
                            style={{
                              backgroundColor:
                                index % 2 === 0 ? "#333" : "#555",
                              color: "white",
                              padding: "10px",
                              textAlign: "left",
                            }}
                          >
                            <span>✅ {plan}</span>
                          </div>
                        ))}
                      </PerfectScrollbar>
                    </div>

                    {/* Get Started Button */}
                    <button
                      className="w-100 "
                      style={{
                        backgroundColor: "#28a745",
                        border: "none",
                        borderRadius: "6px",
                        color: "white",
                        height: "40px",
                        fontSize: "18px",
                        fontWeight: "bold",
                      }}
                    >
                      {selectPlan === pkg.id_subscription_plan_table
                        ? "Selected"
                        : "Get Started"}
                    </button>
                  </Card.Body>
                </Card>
              </SwiperSlide>
            ))}
          </Swiper>
        </Col>
      </Row>
    </Container>
  );
};

export default CardPlan;
